import React from 'react'
import styled from 'styled-components'
import { brand } from '../../config/settings/brand'

const Mark = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: ${({ $size }) => Math.round($size * 0.28)}px;
  background: ${({ theme }) => theme.colors.action.primary.bg};
  color: ${({ theme }) => theme.colors.action.primary.text};
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.12);
`

/**
 * Cotidía brand mark — growth chart motif for pensión alimenticia tracking.
 */
const BrandLogo = ({ size = 32, title = brand.name, className, ...rest }) => {
  const iconSize = Math.round(size * 0.58)

  return (
    <Mark
      $size={size}
      className={className}
      role="img"
      aria-label={title}
      {...rest}
    >
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        {/* Ascending bars */}
        <rect x="3" y="14" width="4" height="7" rx="1.2" fill="currentColor" opacity="0.55" />
        <rect x="10" y="9" width="4" height="12" rx="1.2" fill="currentColor" opacity="0.8" />
        <rect x="17" y="4" width="4" height="17" rx="1.2" fill="currentColor" />
        {/* Soft growth arc */}
        <path
          d="M4 13.5C8 13.5 10.5 8.5 14 7.5C16.5 6.8 18.5 6.2 20 4.5"
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinecap="round"
          opacity="0.95"
        />
      </svg>
    </Mark>
  )
}

export default BrandLogo
